import { render, staticRenderFns } from "./ServiceTypesCategoriesRegistryList.vue?vue&type=template&id=4f668fc1"
import script from "./ServiceTypesCategoriesRegistryList.vue?vue&type=script&lang=js"
export * from "./ServiceTypesCategoriesRegistryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports